/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {useIntl} from 'react-intl'
import {BIRTHDAY_MONTHS} from '../../constants'
export default function useBackInStock({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()
    const backgroundColor = 'white'
    const fields = {
        firstName: {
            name: `${prefix}firstName`,
            label: formatMessage({defaultMessage: 'First Name', id: 'use_fields.label.first_name'}),
            placeholder: 'First Name',
            defaultValue: '',
            type: 'text',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your First Name.',
                    id: 'use_fields.error.required_first_name'
                })
            },
            error: errors?.[`${prefix}firstName`],
            control,
            backgroundColor
        },
        lastName: {
            name: `${prefix}lastName`,
            label: formatMessage({defaultMessage: 'Last Name', id: 'use_fields.label.last_name'}),
            placeholder: 'Last Name',
            defaultValue: '',
            type: 'text',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your Last Name.',
                    id: 'use_fields.error.required_last_name'
                })
            },
            error: errors?.[`${prefix}lastName`],
            control,
            backgroundColor
        },
        email: {
            name: `${prefix}email`,
            label: formatMessage({defaultMessage: 'Email', id: 'use_fields.label.email'}),
            placeholder: 'Email',
            defaultValue: '',
            type: 'email',
            autoComplete: 'email',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your Email.',
                    id: 'use_fields.error.required_email'
                })
            },
            error: errors?.[`${prefix}email`],
            control,
            backgroundColor
        },
        birthday: {
            name: `${prefix}birthday`,
            label: formatMessage({defaultMessage: 'Birthday', id: 'use_fields.label.birthday'}),
            placeholder: 'Make a selection',
            options: BIRTHDAY_MONTHS,
            defaultValue: 'Make a selection',
            type: 'select',
            control,
            backgroundColor
        }
    }
    return fields
}
